import React from 'react'

const signup = () => {
  return (
    <div>signup</div>
  )
}

export default signup